import React from 'react';
import styles from './YourChildAge.module.css';
import { YourChildAgeElement } from '../YourChildAgeElement';

export const DesktopView = (): JSX.Element => {
  const yourChildAgeElement = YourChildAgeElement();
  return (
    <React.Fragment>
      <div className={styles.yourChildsAge}>
        <section
          className={styles.yourChildAgeContactMainGrSection}
          id="your-child-age-contact-main-group"
        >
          <img
            className={styles.desktopHeaderIcon}
            id="desktop-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
          <div className={styles.progressIndicatorDiv}>
            <img
              className={styles.progressIndicator3Icon}
              id="progress-indicator-3"
              alt=""
              src="assets/common/progress-indicator-3.svg"
            />
          </div>

          <div className={styles.craeteParentProfileMainGroDiv}>
            <div
              className={styles.yourChildAgeMainGroupTitlDiv}
              id="your-child-age-main-group-title"
            >
              Select a Level
            </div>
            <div
              className={styles.yourChildAgeMainGroupDescDiv}
              id="your-child-age-main-group-description"
            >
              <p className={styles.weProvideThe}>
                We provide the best learning materials for your kids based on
                their age range.
              </p>
            </div>
            <div className={styles.yourChildAgeMainGroupContFormControl}>
              {yourChildAgeElement.ageSelect}
            </div>

            <section
              className={styles.yourChildAgeMainGroupContSection}
              id="your-child-age-main-group-contact-us-group"
            >
              <span>
                {'If you have any questions, '}
                <a onClick={yourChildAgeElement.contactUsButtonClickHandler}>
                  Contact Us
                </a>
                .
              </span>
            </section>
            <div className={styles.buttons}>
              <div
                className={styles.yourChildAgeMainGroupContButton}
                id="your-child-age-main-group-contnue-button"
              >
                {yourChildAgeElement.continueButton}
              </div>
              <div
                className={styles.yourChildAgeMainGroupBackButton}
                id="your-child-age-main-group-back-button"
              >
                {yourChildAgeElement.backButton}
              </div>
            </div>
          </div>
        </section>

        <div className={styles.desktopRightSideSectionDiv}>
          <img
            className={styles.desktopBgIcon}
            id="desktop-bg"
            alt=""
            src="assets/common/desktop-bg@3x.png"
          />
          <img
            className={styles.youtChildAgeImageIcon}
            id="craete-parent-profile-image"
            alt=""
            src="assets/yourChildAge/yout-child-age-image@3x.png"
          />
        </div>
      </div>
    </React.Fragment>
  );
};
